import {api} from '@/api/factory';

class Derictories {
    constructor() {}

    /**
     * Список директорий хранилища.
     *
     * @param search подстрока относительного пути; отбор идёт на сервере
     *               ДО применения лимита (1000 записей), поэтому находит
     *               папки за его пределами — например, «Ouran High School
     *               Host Club (2006)/RUS Sound/[Cuba77]» (5573 папки
     *               в хранилище на проде)
     */
    get(search: string | null = null) {
        return api.get('/v1/content-manager/directories/search', {
            params: {
                mask: '*',
                search: search
            }
        })
    }
}

export default Derictories;